import React from 'react'
import Page from '../../../../components/Page'
import { features } from './data'
import styles from './styles'

// material
import {
  withStyles,
  TableContainer,
  Table,
  TableBody,
  Paper,
} from '@material-ui/core'
import {
  BottomUpgradeButtons,
  TableHeadComponent,
  TableRowComponent,
} from './components'

const TableInvoice = props => {
  const { plans, handleClick, classes, loading } = props
  const data = plans.filter(item => item.labelAction === 'Current Plan')
  const length = data.length
  return (
    <Page className={classes.rootStyle}>
      <TableContainer className={classes.tableContainer} component={Paper}>
        {features.map(category => (
          <Table className={classes.table} key={category.category}>
            <TableHeadComponent category={category} classes={classes} />
            <TableBody>
              {category.options.map((row, index) => (
                <TableRowComponent key={index} row={row} classes={classes} />
              ))}
              <BottomUpgradeButtons
                category={category}
                plans={plans}
                length={length}
                handleClick={handleClick}
                loading={loading}
              />
            </TableBody>
          </Table>
        ))}
      </TableContainer>
    </Page>
  )
}

export default withStyles(styles)(TableInvoice)
